<template>
    <div :class="generateClasses()">
        <div
            :class="
                isWithoutBody
                    ? ''
                    : 'uk-card-body' +
                      (isDark ? ' dark' : '') +
                      (bodyClass ? ' ' + bodyClass : '')
            ">
            <div
                v-if="title && title.length > 0"
                :class="
                    'title' +
                    (isDark ? ' dark' : '') +
                    (isCentered ? ' uk-text-center' : '')
                ">
                {{ title }}

                <Icon v-if="info" :uk-tooltip="'title:' + info" icon="info" />
            </div>

            <slot />
        </div>

        <div v-if="$slots.labels">
            <slot name="labels" />
        </div>

        <div v-if="$slots.footer" :class="'uk-card-footer ' + footerClass">
            <slot name="footer" />
        </div>
    </div>
</template>

<script>
import Icon from './Icon';

export default {
    name: 'Card',
    components: {Icon},
    props: {
        title: String,
        info: String,
        mode: String,
        isDark: Boolean,
        footerClass: String,
        status: String,
        isBlank: Boolean,
        isCentered: Boolean,
        isWithoutBody: Boolean,
        isRound: Boolean,
        bodyClass: String,
    },
    methods: {
        generateClasses() {
            let classes = '';

            if (this.isCentered) {
                classes += 'uk-text-center';
            }

            if (this.isDark) {
                classes += ' dark';
            }

            if (this.isRound) {
                classes += ' round';
            }

            if (this.isBlank) {
                return classes;
            }

            classes += ' card uk-card uk-card-' + this.mode;

            if (this.status) {
                classes += ' status-' + this.status;
            }

            return classes;
        },
    },
};
</script>

<style lang="scss" scoped>
.uk-card {
    border-radius: $border-radius;
}

.title {
    margin-bottom: 30px;
    text-align: left;
    color: $site-color-hover;
    font-weight: 500;
    font-size: 18px;

    &.dark {
        color: $site-background-hover;
    }
}

.dark {
    color: $site-background-hover;
}

.round {
    border-radius: 5px;
}

.uk-card-warning {
    background: #faa05a;
    color: $theme-color-hover;
}

.uk-card-success {
    background: #32d296;
    color: $theme-color-hover;
}

.uk-card-danger {
    background: #f0506e;
    color: $theme-color-hover;
}

.uk-card-theme {
    background: transparent;
    border: 1px solid $theme-background;
}

.uk-card-theme-hover {
    background: transparent;
    border: 1px solid $theme-background-hover;
}

@media (max-width: $breakpoint-xsmall-max) {
    .uk-card-body {
        padding: 25px;
    }
}

.uk-card-line {
    background: transparent;
    border: 1px solid $border-color;
}

.uk-card-add {
    background: transparent;
    border: 1px dashed #aaa;
    color: #666;
}

.uk-card-default {
    color: $site-color !important;
    //border: 1px solid #E6E6E6;
}

.uk-card-clickandbuy {
    background: #f9fafb;
}

.uk-card-striped {
    background: $striped-color;
    color: $site-color;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}

.status-success {
    box-shadow: 0 5px 15px -5px rgba(50, 210, 150, 0.6) !important;

    &:hover {
        box-shadow: 0 14px 25px -5px rgb(50, 210, 150, 0.8) !important;
    }
}

.uk-card-blur {
    backdrop-filter: saturate(180%) blur(20px);
    background-color: rgba(29, 29, 31, 0.1) !important;
}

.status-danger {
    box-shadow: 0 5px 15px -5px rgba(240, 80, 110, 0.6) !important;

    &:hover {
        box-shadow: 0 14px 25px -5px rgba(240, 80, 110, 0.8) !important;
    }
}
</style>
